<template>
    <div class="courses-single-page bg-dark-blue mt-0" style="overflow-y: auto;">
        <div class="back-button" v-on:click="clearAction" v-if="action !== ''">
            <span>
                Back
            </span>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single">
                            <div class="content">
                                <!--index actions-->
                                <div class="card options-wrapper" v-if="action == ''" style="margin-top: 150px;">
                                    <div class="d-flex justify-content-center">
                                        <div class=" mb-5 text-center" style="font-family: Alibaba-Sans">
                                            <span class="cms-title text-dark-blue">
                                                Courses
                                            </span>
                                            <h4 class="text-dark-blue mt-3">What would you like to do?</h4>
                                        </div>
                                    </div>
                                    <div class="actions-wrapper d-flex justify-content-center">
                                        <router-link to="/admin/courses/0" class="option-tab">
                                            <div class="d-flex flex-column">
                                                <i class="fa fa-2x fa-plus-square"></i>
                                                <span>Create</span>
                                            </div>
                                        </router-link>
                                        <div class="option-tab" v-on:click="setAction($event)">
                                            <div class="d-flex flex-column">
                                                <i class="fa fa-2x fa-tasks"></i>
                                                <span>Manage</span>
                                            </div>
                                        </div>
                                        <div class="option-tab" v-on:click="requestFileModal = true" v-show="userRole == 'admin'">
                                            <div class="d-flex flex-column">
                                                <i class="fa fa-2x fa-upload"></i>
                                                <span>Upload</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--manage-->
                                <div class="table-wrapper" v-if="action == 'manage'">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <div class="title text-white mr-4 mb-2">
                                                Manage courses
                                            </div>
                                            <div class="site-select" v-show="userRole == 'admin' && sites">
                                                <select class="form-control" v-model="selectedSite">
                                                    <option v-for="site in sites" :value="site">{{site.name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-bordered bg-white text-center" style="overflow-y:scroll; max-height: 600px;">
                                            <thead>
                                                <tr>
                                                    <th>Course ID</th>
                                                    <th>Sort order</th>
                                                    <th>Course name</th>
                                                    <th>Category</th>
                                                    <th>Site</th>
                                                    <th>Enabled</th>
                                                    <th>Promoted</th>
                                                    <th>Price</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody style="max-height: 500px; overflow-y: scroll;">
                                                <tr v-for="course in filteredCourses">
                                                    <td>{{ course.id }}</td>
                                                    <td>{{ course.sortOrder }}</td>
                                                    <td>{{ course.name }}</td>
                                                    <td>{{ course.category ? course.category : "N/A" }}</td>
                                                    <td>{{ course.siteName }}</td>
                                                    <td>{{ course.enabled }}</td>
                                                    <td>{{ course.promoted }}</td>
                                                    <td>
                                                        <span v-if="course.priceUsd">R {{ course.price }} / $ {{ course.priceUsd }}</span>
                                                        <span v-else>{{ course.price ? "R" + course.price : "" }}</span>
                                                    </td>
                                                    <td>
                                                        <router-link :to="{ name: 'AdminCourseDetails', params: { id: course.id }}">
                                                            <div class="btn-add-alt-2 d-flex justify-content-center align-items-center text-center p-2">
                                                                <span>
                                                                    Edit
                                                                </span>
                                                                <i class="fa fa-pencil ml-2"></i>
                                                            </div>
                                                        </router-link>
                                                    </td>
                                                    <td>
                                                        <div class="btn-add-alt-2 d-flex justify-content-center align-items-center text-center p-2" v-on:click="exportReport(course)">
                                                            <span>
                                                                Report
                                                            </span>
                                                            <i class="fa fa-file-excel-o ml-2"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-show="filteredCourses.length < 1">
                                                    <td colspan="10">No courses yet</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--new course-->
        <div v-if="requestFileModal" id="upload-file-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form v-on:submit="uploadCourse">
                        <div class="modal-header">
                            <h5 class="modal-title">Upload EdX Course</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="requestFileModal=false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Select your edX course export file and click "Upload" to load the course.</p>
                            <div class="form">
                                <div class="form-group">
                                    <label>New course name</label>
                                    <input class="form-control" type="text" />
                                </div>
                                <div class="form-group">
                                    <label for="upload-file">
                                        Export file
                                    </label>

                                    <input id="upload-file" class="form-control" type="file" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Upload</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="requestFileModal=false">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .back-button{
        z-index: 1000;
        margin-right: 30px;
    }

    .back-button:hover {
        color: #42C1C4 !important;
        background-color: white;
    }

    #upload-file-modal {
        top: 30% !important;
        display: block;
    }

    .cms-title {
        font-size: 60px;
        font-weight: 600;
        color: white;
    }

    .options-wrapper {
        border: 1px solid #282D69;
        padding: 30px;
        border-radius: 12px;
    }

    .option-tab {
        text-align: center;
        text-transform: uppercase;
        width: 30%;
        margin: 10px;
        min-height: 180px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #42C1C4;
        color: white;
        font-size: 40px;
        font-weight: 500;
    }

        .option-tab:hover {
            background-color: white;
            color: #42C1C4;
            text-decoration: none !important;
            cursor: pointer;
        }

    .tab-button {
        border-radius: 8px 8px 0 0;
        border: 1px solid #B8BEBF;
        background-color: #42C1C4;
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        width: 200px;
        padding: 10px;
    }

        .tab-button:hover {
            background-color: white;
            color: #282D69;
            cursor: pointer;
        }

    .btn-edit {
        border: 1px solid #B8BEBF;
        background-color: #42C1C4;
        text-align: center;
        text-transform: uppercase;
    }

        .btn-edit a {
            color: white !important;
            text-decoration: none !important;
        }

        .btn-edit:hover {
            background-color: #282D69;
            color: #fff;
            cursor: pointer;
        }
</style>

<script>
    import ExcelJS from 'exceljs';

    // simple canvas-rendered pie chart, embedded as a picture (neither exceljs nor xlsx can write a native editable Excel chart)
    function drawPieChart(segments) {
        var legendHeight = segments.length * 24 + 10;
        var canvas = document.createElement('canvas');
        canvas.width = 320;
        canvas.height = 300 + legendHeight;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        var total = segments.reduce((sum, s) => sum + s.value, 0) || 1;
        var cx = 150, cy = 150, radius = 130, angle = -Math.PI / 2;
        segments.forEach(s => {
            var slice = (s.value / total) * 2 * Math.PI;
            ctx.beginPath();
            ctx.moveTo(cx, cy);
            ctx.arc(cx, cy, radius, angle, angle + slice);
            ctx.closePath();
            ctx.fillStyle = s.color;
            ctx.fill();
            angle += slice;
        });

        segments.forEach((s, i) => {
            var y = 300 + i * 24 + 10;
            ctx.fillStyle = s.color;
            ctx.fillRect(10, y, 16, 16);
            ctx.fillStyle = '#000000';
            ctx.font = '14px Arial';
            ctx.fillText(`${s.label}: ${s.value}`, 34, y + 13);
        });

        return canvas.toDataURL('image/png').split(',')[1];
    }

    export default {
        name: 'Courses',
        components: {


        },
        props: {

        },
        data() {
            return {
                courses: [],
                requestFileModal: false,
                //create, manage, upload
                action: "",
                isAdmin: false,
                sites: null,
                selectedSite: null
            }
        },
        computed: {
            userRole() {
                if (this.$store.getters.getUser) {
                    var roles = this.$store.state.user.roles;
                    if (roles) {
                        return roles[0];
                    }
                }
            },
            filteredCourses() {
                var filtered = [];

                if (this.userRole == "author") {
                    filtered = this.courses;
                }
                else {
                    for (var i = 0; i < this.courses.length; i++) {
                        var currentCourse = this.courses[i];
                        if (currentCourse.siteName == this.selectedSite.name) {
                            filtered.push(currentCourse);
                        }
                    }
                }
                return filtered;
            },
        },
        methods: {

            async uploadCourse(event) {

                event.preventDefault();
                var formData = new FormData();
                formData.append("file", $("#upload-file")[0].files[0]);
                await this.web("/courses/import", "Importing course...", formData);
                this.courses = await this.web("/courses?filters=admin&filters=all", "Loading courses");
            },

            setAction(event) {
                var action;
                if ($(event.target).is("i")) {
                    action = $(event.target).siblings("span")[0].innerText.toLowerCase();
                }
                else {
                    action = event.target.innerText.toLowerCase();
                }
                this.action = action;

                var crumbs = {};
                crumbs["/admin/courses"] = "Courses" + " / Manage courses";
                this.$store.commit("breadCrumbs", crumbs);

            },

            clearAction() {
                this.action = "";
                var crumbs = {};
                crumbs["/admin/courses"] = "Courses";
                this.$store.commit("breadCrumbs", crumbs);
            },

            exportReport: async function (course) {

                // fetch a fresh list that also includes soft-deleted users
                var allUsers = await this.web(`/users?includeDeleted=true`, "Building report") || [];
                var excludedEmails = ["emloulock@gmail.com"];
                var isExcluded = x => (x.email || "").toLowerCase().endsWith("@elevatex.tech") ||
                    excludedEmails.includes((x.email || "").toLowerCase());
                var activeUsers = allUsers.filter(x => x.siteId == course.siteId && !x.isDeleted && !isExcluded(x));

                // names are entered inconsistently (ALL CAPS, all lowercase, stray spaces) - normalize for display
                var titleCase = s => (s || "").trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
                var fullName = u => `${titleCase(u.firstName)} ${titleCase(u.lastName)}`.trim();
                var courseEntryOf = u => (u.userCourses || []).find(uc => uc.courseId == course.id);
                var earliestEntryOf = u => (u.userCourses || []).slice()
                    .sort((a, b) => new Date(a.createdDateTime) - new Date(b.createdDateTime))[0];

                var enrolledUsers = activeUsers.filter(u => courseEntryOf(u));
                var notEnrolledUsers = activeUsers.filter(u => !courseEntryOf(u));
                var completedUsers = enrolledUsers.filter(u => courseEntryOf(u).completed);
                var notCompletedUsers = enrolledUsers.filter(u => !courseEntryOf(u).completed);
                var failedUsers = enrolledUsers.filter(u => courseEntryOf(u).passed === false);
                var completedNotFailedUsers = completedUsers.filter(u => courseEntryOf(u).passed !== false);
                var inProgressUsers = notCompletedUsers.filter(u => courseEntryOf(u).passed !== false);

                // one row for a user against a specific enrollment (or a blank enrollment if uc is null)
                var toRow = (u, uc) => ({
                    Email: u.email,
                    Name: titleCase(u.firstName),
                    Surname: titleCase(u.lastName),
                    Course: uc && uc.course ? uc.course.name : "",
                    "Enrolled Date": uc ? uc.createdDateTime : "",
                    Completed: uc ? uc.completed : "",
                    "Completed Date": uc ? (uc.completedDateTime || "") : "",
                    Score: uc ? uc.score : "",
                    Passed: uc ? uc.passed : ""
                });

                // completed users first, then everyone else still enrolled
                var courseUsersRows = enrolledUsers.slice()
                    .sort((a, b) => (courseEntryOf(a).completed ? 0 : 1) - (courseEntryOf(b).completed ? 0 : 1))
                    .map(u => toRow(u, courseEntryOf(u)));
                var registeredRows = activeUsers.map(u => toRow(u, earliestEntryOf(u)));
                var masterRows = activeUsers.flatMap(u => (u.userCourses && u.userCourses.length)
                    ? u.userCourses.map(uc => toRow(u, uc))
                    : [toRow(u, null)]);

                // Excel sheet names: max 31 chars, no : \ / ? * [ ]
                var sheetName = name => name.replace(/[:\\/?*[\]]/g, "").substring(0, 31);
                var dataColumns = [
                    { header: "Email", key: "Email", width: 30 },
                    { header: "Name", key: "Name", width: 18 },
                    { header: "Surname", key: "Surname", width: 18 },
                    { header: "Course", key: "Course", width: 45 },
                    { header: "Enrolled Date", key: "Enrolled Date", width: 24 },
                    { header: "Completed", key: "Completed", width: 12 },
                    { header: "Completed Date", key: "Completed Date", width: 24 },
                    { header: "Score", key: "Score", width: 10 },
                    { header: "Passed", key: "Passed", width: 10 }
                ];
                var styleHeaderRow = sheet => {
                    sheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
                    sheet.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } };
                    sheet.views = [{ state: "frozen", ySplit: 1 }];
                };

                var workbook = new ExcelJS.Workbook();

                var statsSheet = workbook.addWorksheet("Statistics");
                statsSheet.columns = [{ width: 65 }, { width: 12 }];
                // consecutive total rows (no name rows between them) alternate to grey so they stay visually distinct
                var lastRowWasTotal = false;
                var addStatTotal = (label, count) => {
                    var row = statsSheet.addRow([label, count]);
                    if (lastRowWasTotal) {
                        row.font = { bold: true, color: { argb: "FF000000" } };
                        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE4E4E7" } };
                    } else {
                        row.font = { bold: true, color: { argb: "FFFFFFFF" } };
                        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } };
                    }
                    lastRowWasTotal = true;
                };
                var addStatName = name => {
                    statsSheet.addRow([name, ""]);
                    lastRowWasTotal = false;
                };

                addStatTotal("Total users registered on platform:", activeUsers.length);
                addStatTotal(`Users who registered on platform but not enrolled in ${course.name} course:`, notEnrolledUsers.length);
                notEnrolledUsers.forEach(u => addStatName(fullName(u)));
                addStatTotal(`Total users who have enrolled in ${course.name} course:`, enrolledUsers.length);
                addStatTotal(`Total users who have completed the ${course.name} course:`, completedUsers.length);
                completedUsers.forEach(u => addStatName(fullName(u)));
                addStatTotal(`Users enrolled in the ${course.name} course but not yet completed:`, notCompletedUsers.length);
                notCompletedUsers.forEach(u => addStatName(fullName(u)));
                addStatTotal(`Total users who failed the ${course.name} course:`, failedUsers.length);
                failedUsers.forEach(u => addStatName(fullName(u)));

                if (enrolledUsers.length) {
                    var chartBase64 = drawPieChart([
                        { label: "Passed", value: completedNotFailedUsers.length, color: "#A3B399" },
                        { label: "Failed", value: failedUsers.length, color: "#B03737" },
                        { label: "Not Yet Completed", value: inProgressUsers.length, color: "#D5A438" }
                    ]);
                    var imageId = workbook.addImage({ base64: chartBase64, extension: "png" });
                    statsSheet.addImage(imageId, { tl: { col: 3, row: 3 }, ext: { width: 320, height: 372 } });
                }

                var courseSheet = workbook.addWorksheet(sheetName(course.name));
                courseSheet.columns = dataColumns;
                courseSheet.addRows(courseUsersRows);
                styleHeaderRow(courseSheet);

                var registeredSheet = workbook.addWorksheet("Users Registered on Platform");
                registeredSheet.columns = dataColumns;
                registeredSheet.addRows(registeredRows);
                styleHeaderRow(registeredSheet);

                var masterSheet = workbook.addWorksheet("Master");
                masterSheet.columns = dataColumns;
                masterSheet.addRows(masterRows);
                styleHeaderRow(masterSheet);

                var today = new Date();
                var reportDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

                var buffer = await workbook.xlsx.writeBuffer();
                var blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                var url = URL.createObjectURL(blob);
                var pom = document.createElement("a");
                pom.href = url;
                pom.setAttribute("download", `${course.name}-report-${reportDate}.xlsx`);
                pom.click();
                URL.revokeObjectURL(url);
            },
        },
        async mounted() {
            if (this.userRole == "admin") {
                this.courses = await this.web("/courses?filters=all&filters=admin", "Loading courses");
                this.sites = await this.web('/sites', "Loading sites");
                this.selectedSite = this.sites[0];
            }
            else {
                this.courses = await this.web("/courses?filters=all", "Loading courses");
            }

            var crumbs = {};
            crumbs["/admin/courses"] = "Courses";
            this.$store.commit("breadCrumbs", crumbs);
        }

    }
</script>
